import React, { useState } from 'react';
import store from '@apply/adminStore';
import ActionSheet from 'devextreme-react/action-sheet';
import { getActions, executeAction } from '../BorrowerFunctions';
import { InformModal } from '../../../common/SharedComponents';
import { useNavigate } from 'react-router-dom';

export const ActionsButton = ({ data, parentId }) => {
    const navigate = useNavigate();

    const { dispatch } = store;
    const { user } = store.getState();

    const [actionData, set_actionData] = useState({
        visible: false,
        target: null,
        items: [],
    });
    const [informModalOpen, set_informModalOpen] = useState(false);

    const onActionClicked = (event, rowItem) => {
        event.preventDefault();
        event.stopPropagation();

        const actions = getActions(rowItem, user);

        if (actions.length === 0) {
            set_informModalOpen(true);
            return;
        }

        var data = {
            items: actions,
            target: `#${event.target.id}`,
            visible: true,
        };
        set_actionData(data);
    };

    const onActionItemClick = (e) => {
        set_actionData({ ...actionData, visible: false });
        executeAction(e.itemData, navigate);
    };

    const onActionSheetVisibleChange = (isVisible) => {
        if (isVisible !== actionData?.visible) {
            set_actionData({ ...actionData, visible: isVisible });
        }
    };

    const isVisible = (rowItem) => {
        const actions = getActions(rowItem, user);
        return actions.length > 0;
    };

    if (!data) {
        return null;
    }

    if (!data || !isVisible(data)) {
        return null;
    }

    return (
        <>
            <button
                id={`${parentId}_action_${data.companyId ?? 0}_${data.entityId ?? 0}_${data.principalId ?? 0}_${data.linkType}`}
                className='gridButton'
                title='Click to see options'
                onClick={(event) => onActionClicked(event, data)}
            >
                ...
            </button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onActionSheetVisibleChange}
                showTitle={false}
            />
            <InformModal
                isOpen={informModalOpen}
                text={'No actions available'}
                confirmCallback={() => set_informModalOpen(false)}
            />
        </>
    );
};
